module.exports = __webpack_public_path__ + "img/2133.e66e89ee.gif";